<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready && selects.ready">
            <div class="card mb-3">
                <div class="card-title" v-once>
                    <span>Замена товара – #{{ entry.id }} ({{ entry.product.name }})</span>
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div class="flex -mx-2">
                        <select-field
                            class="w-1/2 px-2"
                            title="Новый товар"
                            label="name"
                            valueName="id"
                            :options="products"
                            v-model="replacement.product_id"
                            @input="setAmount"
                            :errors="errors.product_id"
                            :clearable="false"
                            required
                        />

                        <text-field
                            type="number"
                            class="w-1/2 px-2"
                            title="Доплата"
                            v-model="replacement.amount"
                            :errors="errors.amount"
                            required
                        />
                    </div>

                    <hr class="mb-3" />

                    <button :disabled="saving" class="btn btn-primary">Отправить</button>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import qs from "qs";

export default {
    extends: ResourceForm,

    data() {
        return {
            resource: {
                name: "admin.billing.orders",
                endpoint: "admin/billing/orders"
            },

            selects: {
                ready: false,
                products: []
            },

            replacement: {
                product_id: null,
                amount: null
            }
        };
    },

    computed: {
        products() {
            return this.selects.products.filter(
                product => product.id != this.entry.product_id
            );
        }
    },

    methods: {
        setAmount() {
            this.replacement.amount =
                this.selects.products.find(
                    product => product.id == this.replacement.product_id
                ).price - this.entry.product.price;
        },

        async fetchSelects() {
            await axios
                .get("/admin/products/all", {
                    params: {
                        filters: {
                            sellable: 1
                        }
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params);
                    }
                })
                .then(response => {
                    this.selects.products = response.data.data;
                });

            this.selects.ready = true;
        },

        submit() {
            axios
                .post(
                    `/admin/billing/orders/${this.entry.id}/replace`,
                    this.replacement
                )
                .then(response => {
                    this.$message.success("Товар заменен");

                    this.$router.push({
                        name: "admin.billing.orders.edit",
                        params: {
                            id: this.entry.id
                        }
                    });
                });
        }
    },

    mounted() {
        this.fetchSelects();
    }
};
</script>